import React from 'react'
import { Link } from 'react-router-dom'
import LeftLayout from './LeftLayout'

const Baskets = () => {
    return (
        <div className='basket myBasket'>
            <LeftLayout>
                <div className="row">
                    <div className="col-lg-8 middle pt-5">
                        <div className="tableMobile">
                            <div className="tableCards mb-4">
                                <div className="bg"><img src="/assets/image/cardBg2.png" alt="" /></div>
                                <div>
                                    <div className="img">
                                        <img src="/assets/image/basketImg.png" alt="" />
                                        <p>XS</p>
                                        <i className="marell"><img src="/assets/image/marellMini.png" alt="" /></i>
                                        <div className="icon icon-heart"></div>
                                        <div className="trash"><img src="/assets/icon/trash_full.svg" alt="" /></div>
                                    </div>
                                    <h4>- <span className="mx-4">1</span> +</h4>
                                </div>
                                <div className='content'>
                                    <h1>Футболка “Marell” </h1>
                                    <div className="d-flex">
                                        <div className='mr-4'>
                                            <h2>RUB</h2>
                                            <h3>1600 P</h3>
                                        </div>
                                        <div>
                                            <h2 className='pink'>AMARELL</h2>
                                            <h3>94</h3>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="tableCards mb-4">
                                <div className="bg"><img src="/assets/image/cardBg2.png" alt="" /></div>
                                <div>
                                    <div className="img">
                                        <img src="/assets/image/basketImg.png" alt="" />
                                        <p>XS</p>
                                        <i className="marell"><img src="/assets/image/marellMini.png" alt="" /></i>
                                        <div className="icon icon-heart"></div>
                                        <div className="trash"><img src="/assets/icon/trash_full.svg" alt="" /></div>
                                    </div>
                                    <h4>- <span className="mx-4">1</span> +</h4>
                                </div>
                                <div className='content'>
                                    <h1>Футболка “Marell” </h1>
                                    <div className="d-flex">
                                        <div className='mr-4'>
                                            <h2>RUB</h2>
                                            <h3>1600 P</h3>
                                        </div>
                                        <div>
                                            <h2 className='pink'>AMARELL</h2>
                                            <h3>94</h3>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="tableCards ">
                                <div className="bg"><img src="/assets/image/cardBg2.png" alt="" /></div>
                                <div>
                                    <div className="img">
                                        <img src="/assets/image/basketImg.png" alt="" />
                                        <p>XS</p>
                                        <i className="marell"><img src="/assets/image/marellMini.png" alt="" /></i>
                                        <div className="icon icon-heart"></div>
                                        <div className="trash"><img src="/assets/icon/trash_full.svg" alt="" /></div>
                                    </div>
                                    <h4>- <span className="mx-4">1</span> +</h4>
                                </div>
                                <div className='content'>
                                    <h1>Футболка “Marell” </h1>
                                    <div className="d-flex">
                                        <div className='mr-4'>
                                            <h2>RUB</h2>
                                            <h3>1600 P</h3>
                                        </div>
                                        <div>
                                            <h2 className='pink'>AMARELL</h2>
                                            <h3>94</h3>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="cards">
                            <table className="table">
                                <thead>
                                    <tr>
                                        <th>товар</th>
                                        <th>кол-во</th>
                                        <th>цена</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    <tr>
                                        <th>
                                            <div className="d-flex align-items-center">
                                                <div className="img">
                                                    <img src="/assets/image/basketImg.png" alt="" />
                                                    <p>XS</p>
                                                    <i className="marell"><img src="/assets/image/marellMini.png" alt="" /></i>
                                                    <div className="icon icon-heart"></div>
                                                    <div className="trash"><img src="/assets/icon/trash_full.svg" alt="" /></div>
                                                </div>
                                                <h6>Футболка “Marell” </h6>
                                            </div>
                                        </th>
                                        <th>
                                            <div className="d-flex align-items-center">
                                                <h5>-</h5>
                                                <h5>1</h5>
                                                <h5>+</h5>
                                            </div>
                                        </th>
                                        <th>
                                            <div className="d-flex">
                                                <div className='mr-3'>
                                                    <h3>RUB</h3>
                                                    <h4>1600 P</h4>
                                                </div>
                                                <div>
                                                    <h3 className='pink'>AMARELL</h3>
                                                    <h4>94</h4>
                                                </div>
                                            </div>
                                        </th>
                                    </tr>
                                    <tr>
                                        <th>
                                            <div className="d-flex align-items-center">
                                                <div className="img">
                                                    <img src="/assets/image/basketImg.png" alt="" />
                                                    <p>XS</p>
                                                    <i className="marell"><img src="/assets/image/marellMini.png" alt="" /></i>
                                                    <div className="icon icon-heart"></div>
                                                    <div className="trash"><img src="/assets/icon/trash_full.svg" alt="" /></div>
                                                </div>
                                                <h6>Футболка “Marell” </h6>
                                            </div>
                                        </th>
                                        <th>
                                            <div className="d-flex align-items-center">
                                                <h5>-</h5>
                                                <h5>1</h5>
                                                <h5>+</h5>
                                            </div>
                                        </th>
                                        <th>
                                            <div className="d-flex">
                                                <div className='mr-3'>
                                                    <h3>RUB</h3>
                                                    <h4>1600 P</h4>
                                                </div>
                                                <div>
                                                    <h3 className='pink'>AMARELL</h3>
                                                    <h4>94</h4>
                                                </div>
                                            </div>
                                        </th>
                                    </tr>
                                    <tr>
                                        <th>
                                            <div className="d-flex align-items-center">
                                                <div className="img">
                                                    <img src="/assets/image/basketImg.png" alt="" />
                                                    <p>XS</p>
                                                    <i className="marell"><img src="/assets/image/marellMini.png" alt="" /></i>
                                                    <div className="icon icon-heart"></div>
                                                    <div className="trash"><img src="/assets/icon/trash_full.svg" alt="" /></div>
                                                </div>
                                                <h6>Футболка “Marell” </h6>
                                            </div>
                                        </th>
                                        <th>
                                            <div className="d-flex align-items-center">
                                                <h5>-</h5>
                                                <h5>1</h5>
                                                <h5>+</h5>
                                            </div>
                                        </th>
                                        <th>
                                            <div className="d-flex">
                                                <div className='mr-3'>
                                                    <h3>RUB</h3>
                                                    <h4>1600 P</h4>
                                                </div>
                                                <div>
                                                    <h3 className='pink'>AMARELL</h3>
                                                    <h4>94</h4>
                                                </div>
                                            </div>
                                        </th>
                                    </tr>
                                    <tr>
                                        <th>
                                            <div className="d-flex align-items-center">
                                                <div className="img">
                                                    <img src="/assets/image/basketImg.png" alt="" />
                                                    <p>XS</p>
                                                    <i className="marell"><img src="/assets/image/marellMini.png" alt="" /></i>
                                                    <div className="icon icon-heart"></div>
                                                    <div className="trash"><img src="/assets/icon/trash_full.svg" alt="" /></div>
                                                </div>
                                                <h6>Футболка “Marell” </h6>
                                            </div>
                                        </th>
                                        <th>
                                            <div className="d-flex align-items-center">
                                                <h5>-</h5>
                                                <h5>1</h5>
                                                <h5>+</h5>
                                            </div>
                                        </th>
                                        <th>
                                            <div className="d-flex">
                                                <div className='mr-3'>
                                                    <h3>RUB</h3>
                                                    <h4>1600 P</h4>
                                                </div>
                                                <div>
                                                    <h3 className='pink'>AMARELL</h3>
                                                    <h4>94</h4>
                                                </div>
                                            </div>
                                        </th>
                                    </tr>
                                    <tr>
                                        <th>
                                            <div className="d-flex align-items-center">
                                                <div className="img">
                                                    <img src="/assets/image/basketImg.png" alt="" />
                                                    <p>XS</p>
                                                    <i className="marell"><img src="/assets/image/marellMini.png" alt="" /></i>
                                                    <div className="icon icon-heart"></div>
                                                    <div className="trash"><img src="/assets/icon/trash_full.svg" alt="" /></div>
                                                </div>
                                                <h6>Футболка “Marell” </h6>
                                            </div>
                                        </th>
                                        <th>
                                            <div className="d-flex align-items-center">
                                                <h5>-</h5>
                                                <h5>1</h5>
                                                <h5>+</h5>
                                            </div>
                                        </th>
                                        <th>
                                            <div className="d-flex">
                                                <div className='mr-3'>
                                                    <h3>RUB</h3>
                                                    <h4>1600 P</h4>
                                                </div>
                                                <div>
                                                    <h3 className='pink'>AMARELL</h3>
                                                    <h4>94</h4>
                                                </div>
                                            </div>
                                        </th>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        {/* <BasketImg /> */}
                    </div>

                    <div className="col-lg-4 rightBasket">

                        <div className="cards shadows">
                            <div className="cardsBody">
                                <div className="d-flex align-items-center justify-content-between">
                                    <h2>Промежуточный итог</h2>
                                    <h2>20 000 р / 500 AMARELL</h2>
                                </div>
                            </div>
                            <div className="cardsBody">
                                <div className="d-flex align-items-center justify-content-between">
                                    <h2>Доставка: Бесплатно</h2>
                                </div>
                            </div>
                            <div className="cardsBody">
                                <div className="d-flex align-items-center justify-content-between">
                                    <h2>ИТОГ: </h2>
                                    <h2>20 000 р / 500 AMARELL</h2>
                                </div>

                                <Link to='/basket/checkout' className="btn">Перейти к оформлению</Link>
                            </div>
                        </div>
                        {/* <Basket /> */}
                    </div>
                </div>
            </LeftLayout>
        </div>
    )
}

export default Baskets
